import { Menu, MoreHoriz, Search } from '@mui/icons-material';
import { Link } from 'wouter';
import Title from '~/elements/Title/Title';
import { useFile, useWikis } from '~/utils/hooks/hooks';
import { useActionsDrawerOpen, useMobileSearchOpen, useSidebarOpen } from '~/utils/store';
import * as styles from './HeaderMobile.css';

type Props = {
  wikiId: string;
};

export const HeaderMobile = ({ wikiId }: Props) => {
  const { data: wikis = [] } = useWikis();
  const { data: wiki } = useFile(wikiId, wikis, wikiId);
  const [sidebarOpen, setSidebarOpen] = useSidebarOpen();
  const [mobileSearchOpen, setMobileSearchOpen] = useMobileSearchOpen();
  const [, setActionsDrawerOpen] = useActionsDrawerOpen();

  const backgroundColor = wiki?.properties?.color ?? '#638AF5';
  const fontColor = wiki?.properties?.fontColor ?? '#fff';

  return (
    <header className={styles.header} style={{ backgroundColor }}>
      <div className={styles.content}>
        <div className={styles.left}>
          <button
            type="button"
            className={styles.iconButton}
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
          >
            <Menu style={{ color: fontColor }} />
          </button>
        </div>
        <div className={styles.center}>
          <Link href={`/app/page/${wikiId}`} className={styles.link} style={{ color: fontColor }}>
            <Title className={styles.title}>{wiki?.name}</Title>
          </Link>
        </div>
        <div className={styles.right}>
          <button
            type="button"
            className={styles.iconButton}
            onClick={() => setMobileSearchOpen(!mobileSearchOpen)}
            aria-label="Toggle search"
          >
            <Search style={{ color: fontColor }} />
          </button>
          <button
            type="button"
            className={styles.iconButton}
            onClick={() => setActionsDrawerOpen(true)}
            aria-label="More actions"
          >
            <MoreHoriz style={{ color: fontColor }} />
          </button>
        </div>
      </div>
    </header>
  );
};
